import { addYears } from 'date-fns'

export default {
  name: 'project_start_date',
  component_path: 'modules/procedures/blocks/BlockInputDate',
  default_value: 'default_values.project.start_date',
  static_options: {
    open_date: new Date(),
    show_time: true
  },
  static_mandatory: [
    'required',
    `minDate:${new Date().toISOString()}`,
    `maxDate:${addYears(new Date(), 10).toISOString()}`,
    'maxDate:procedure.default_values.project.end_date',
    'maxDate:procedure_execution.actions_data.project.end_date'
  ]
}